if (!customElements.get('anso-products')) {
  customElements.define('anso-products', class extends HTMLElement {
    connectedCallback() {
      this.listeners = new AbortController();
      this.querySelector('[data-products-retry]').addEventListener('click', () => this.load(), { signal: this.listeners.signal });
      this.load();
    }
    disconnectedCallback() {
      this.listeners.abort();
      this.controller?.abort();
      clearTimeout(this.timeout);
      this.loading = false;
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      const controller = this.controller = new AbortController();
      const content = this.querySelector('[data-products-content]');
      const retry = this.querySelector('[data-products-retry]');
      const errorPanel = this.querySelector('[data-products-error]');
      const status = this.querySelector('[data-products-status]');
      const retryHadFocus = document.activeElement === retry;
      retry.disabled = true;
      errorPanel.hidden = true;
      this.querySelector('[data-products-empty]').hidden = true;
      status.textContent = '';
      content.setAttribute('aria-busy', 'true');
      const loading = document.createElement('p');
      loading.setAttribute('role', 'status');
      loading.textContent = this.dataset.loadingText;
      content.replaceChildren(loading);
      if (!this.dataset.url) {
        content.replaceChildren();
        content.setAttribute('aria-busy', 'false');
        this.querySelector('[data-products-empty]').hidden = false;
        retry.disabled = false;
        this.loading = false;
        return;
      }
      let timedOut = false;
      this.timeout = setTimeout(() => { timedOut = true; controller.abort(); }, 15000);
      try {
        const response = await fetch(this.dataset.url, { signal: controller.signal });
        if (!response.ok) throw new Error('Products unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = html.querySelector('[data-product-results]');
        if (!grid) throw new Error('Product section unavailable');
        if (this.controller !== controller || !this.isConnected) return;
        // Scope card IDs per instance: the same product can be a bestseller and a new arrival.
        const prefix = this.closest('[id]')?.id || 'anso-products';
        const ids = new Map();
        grid.querySelectorAll('[id]').forEach((node) => {
          ids.set(node.id, `${prefix}-${node.id}`);
          node.id = ids.get(node.id);
        });
        grid.querySelectorAll('[aria-labelledby], [aria-describedby], [for]').forEach((node) => {
          ['aria-labelledby', 'aria-describedby', 'for'].forEach((attr) => {
            if (node.hasAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).split(' ').map((id) => ids.get(id) || id).join(' '));
          });
        });
        [...grid.children].slice(Number(this.dataset.count)).forEach((item) => item.remove());
        content.replaceChildren(grid);
        this.querySelector('[data-products-empty]').hidden = grid.children.length > 0;
        status.textContent = grid.children.length ? this.dataset.loadedText : '';
        if (retryHadFocus) {
          content.setAttribute('tabindex', '-1');
          content.focus({ preventScroll: true });
        }
      } catch (error) {
        if (this.controller !== controller || !this.isConnected || (error.name === 'AbortError' && !timedOut)) return;
        content.replaceChildren();
        errorPanel.hidden = false;
      } finally {
        if (this.controller === controller) {
          clearTimeout(this.timeout);
          this.loading = false;
          content.setAttribute('aria-busy', 'false');
          retry.disabled = false;
          if (retryHadFocus && !errorPanel.hidden) retry.focus({ preventScroll: true });
        }
      }
    }
  });
}
